import Dashboard from "./Dashboard";

const routes = [
    {
        path: 'dashboard',
        element: <Dashboard />
    }
]
export default routes;